module.exports = __webpack_public_path__ + "img/0Q3B1891_L_Wood_MockedUp.31024a2b.jpg";